"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.TransactionType=void 0;var i;(function(e){e.Acquisition="acquisition",e.Reorder="reorder"})(i||(exports.TransactionType=i={}));
//# sourceMappingURL=TransactionType.js.map
